module.exports = __webpack_public_path__ + "static/img/autumn.83c458e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/units/s_tree1_adult/autumn.png
// module id = rISv
// module chunks = 1